import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
// QUINLAN
import BaseMixer from "../../BaseMixer";
import simplebar from "simplebar-vue";
let MultiSelectComponent = /** @class */ (() => {
    let MultiSelectComponent = class MultiSelectComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isShow = false;
        }
        get isShowCard() {
            return this.models.length > 0;
        }
        showList() {
            this.isShow = !this.isShow;
        }
        handleItemClick(item) {
            const index = this.items.findIndex((i) => i.id === item.id);
            if (index !== -1) {
                this.models.push(this.items.splice(index, 1)[0]);
            }
        }
        removeModel(item) {
            const index = this.models.findIndex((i) => i.id === item.id);
            if (index !== -1) {
                this.items.push(this.models.splice(index, 1)[0]);
            }
        }
        updateValue() {
            for (const model of this.models) {
                const index = this.items.findIndex((item) => item.id === model.id);
                if (index !== -1) {
                    this.items.splice(index, 1);
                }
            }
        }
        onIsUnderEditChange() {
            if (this.isUnderEdit === true) {
                if (this.models.length > 0) {
                    this.updateValue();
                }
            }
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], MultiSelectComponent.prototype, "items", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], MultiSelectComponent.prototype, "models", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], MultiSelectComponent.prototype, "isUnderEdit", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], MultiSelectComponent.prototype, "drawerName", void 0);
    __decorate([
        Watch("isUnderEdit", { immediate: true }),
        Watch("models", { immediate: true, deep: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MultiSelectComponent.prototype, "onIsUnderEditChange", null);
    MultiSelectComponent = __decorate([
        Component({
            name: "MultiSelectComponent",
            components: {
                simplebar,
            },
        })
    ], MultiSelectComponent);
    return MultiSelectComponent;
})();
export default MultiSelectComponent;
